import { COOKIE_ID } from '@df/core/service/multisite';

export namespace NDfPrivacy {
    export enum AREA {
        core,
        performance,
        personalisation,
        advertising
    }

    /**
     * default setting if no values were saved
     */
    export const AREAS_SETTINGS = {
        performance: true,
        personalisation: true,
        advertising: true,
        //number of days after we clear local storage privacy settings and ask customer to approve again, 0 if not expiring
        expiringAfter: 0
    };

    export const ALLOWED_AREAS: { [key: string]: boolean | (string | RegExp)[] } = {};
    
    ALLOWED_AREAS[AREA.core] = [/^frontend/i, /^phpsessid/i, COOKIE_ID];
    ALLOWED_AREAS[AREA.performance] = [
        '_ga',
        '_gid',
        '_gaexp',
        '_gat',
        'AMP_TOKEN',
        /^__utm/,
        /^_gac_/,
        '__exponea_etc__',
        '_cs_s',
        '_cs_cvars',
        '_cs_ex',
        '_cs_c',
        '_cs_optout',
        '_cs_mk',
        '_cs_rl'
    ];
    ALLOWED_AREAS[AREA.personalisation] = true;
    ALLOWED_AREAS[AREA.advertising] = false;

    export interface ICookiesDefinition {
        area: AREA;
        test: string | RegExp;
    }

    export interface IPrivacyData {
        core?: boolean;
        performance?: boolean;
        personalisation?: boolean;
    }

    export interface IPrivacySettings {
        [key: string]: boolean | string;
    }
}
